import React from 'react';
import styled from 'styled-components';

// Styled components for the UI
const GalleryContainer = styled.div`
  background: #f9f9f9;
  padding: 25px;
  width: 100%;
  margin: 20px 0; /* Ensure there's no horizontal centering to start from the left */
  border-radius: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
`;

const GalleryTitle = styled.h2`
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin: 0; /* Remove margin to start from the left */
  text-align: left;
  padding-left: 10px; /* Add slight padding to ensure title isn't stuck to the edge */
`;

const ImageWrapper = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 25px; /* Space between images */
  padding: 10px 0; /* Adjusted padding to ensure it stays tight */
  scroll-snap-type: x mandatory;
  padding-left: 10px; /* Start from the left of the container */
`;

const ImageCard = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  width: 200px; /* Reduced width */
  height: 200px; /* Reduced height */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  scroll-snap-align: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05); /* Hover effect to scale the image */
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }
`;

const images = [
  '/images/court2.jpg',
  '/images/BadmintonImage.jpg',
  '/images/BadmintonImage.png',
  '/images/FootballImage.jpg',
  '/images/CricketImage.jpg',
  '/images/court1.png',
  '/images/court2.jpg',
  '/images/BadmintonImage.jpg',
  '/images/CricketImage.jpg',

];

const Gallery = () => {
  return (
    <GalleryContainer>
      <GalleryTitle>Our Gallery</GalleryTitle>
      <ImageWrapper>
        {images.map((src, index) => (
          <ImageCard key={index}>
            <img src={src} alt={`Gallery Image ${index + 1}`} />
          </ImageCard>
        ))}
      </ImageWrapper>
    </GalleryContainer>
  );
};

export default Gallery;
